import React, { Component } from 'react';

import styles from './Footer.module.css';

class Footer extends Component {
  render() {
    return (
      <footer className={styles.footer}>
        {this.props.amazondisclaimer && 
          <div className={styles.amazondisclaimer}>** Amazon Partnerlink - Als Amazon-Partner verdiene ich an qualifizierten Verkäufen.</div>}
        <div>🍪 Cookie FREE!</div>
        import React, { Component } from 'react';
        <div className={styles.buildId}>Build ID: {process.env.REACT_APP_BUILD_ID || 'dev'}</div>
      </footer>
    )
  }
}

export default (Footer)